<template>
    <div>
        信息动态
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="sass" scoped>

</style>